export default function ShieldAvatar() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_813_17343"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="2"
        y="2"
        width="12"
        height="14"
      >
        <path d="M14 2H2V15.8752H14V2Z" fill="white" />
      </mask>
      <g mask="url(#mask0_813_17343)">
        <path
          d="M8.08625 15.828C8.05839 15.8472 8.02579 15.8574 7.99249 15.8574C7.95918 15.8574 7.92658 15.8472 7.89873 15.828L4.64936 13.5991C4.62576 13.5825 4.60642 13.5601 4.59305 13.5339C4.57967 13.5076 4.57268 13.4783 4.57268 13.4485C4.57268 13.4187 4.57967 13.3895 4.59305 13.3632C4.60642 13.3369 4.62576 13.3145 4.64936 13.298L13.7197 7.07382C13.7457 7.05643 13.7756 7.04655 13.8063 7.0452C13.8371 7.0438 13.8677 7.05097 13.895 7.06591C13.9229 7.08095 13.9463 7.10358 13.9628 7.13151C13.9793 7.15939 13.9883 7.19151 13.9888 7.22437V11.6831C13.9888 11.7131 13.9817 11.7425 13.9681 11.7688C13.9545 11.7951 13.9348 11.8174 13.911 11.8337L8.08625 15.828ZM3.14936 12.5698C3.17736 12.5886 3.20989 12.5985 3.24311 12.5985C3.27632 12.5985 3.30884 12.5886 3.33686 12.5698L13.9072 5.31627C13.9311 5.3 13.9508 5.27769 13.9644 5.25139C13.978 5.22509 13.985 5.19563 13.985 5.16571V2.26077C13.985 2.21301 13.9669 2.16721 13.9348 2.13344C13.9026 2.09966 13.8589 2.08069 13.8134 2.08069H11.5494C11.516 2.08059 11.4834 2.09086 11.4556 2.1102L2.08061 8.54497C2.05675 8.56131 2.03716 8.5836 2.02357 8.60991C2.00999 8.63621 2.00283 8.66563 2.00279 8.69552V11.6831C2.00275 11.7131 2.00984 11.7425 2.02344 11.7688C2.03703 11.7951 2.05669 11.8174 2.08061 11.8337L3.14936 12.5698ZM2 6.63686C2.00004 6.66928 2.00843 6.7011 2.02426 6.72893C2.0401 6.75677 2.06278 6.77963 2.08995 6.79505C2.11712 6.81044 2.14776 6.81787 2.17862 6.81655C2.20948 6.8152 2.23945 6.80515 2.26532 6.78745L8.64034 2.41133C8.67115 2.39008 8.69463 2.35896 8.70729 2.32258C8.71995 2.28621 8.72111 2.24652 8.71058 2.2094C8.70005 2.17228 8.67844 2.13971 8.64888 2.11652C8.61932 2.09334 8.58347 2.08077 8.54659 2.08069H2.17157C2.12607 2.08069 2.08239 2.09966 2.05022 2.13344C2.01804 2.16721 2 2.21301 2 2.26077V6.63686Z"
          fill="#44ABCA"
          className="path-fill"
        />
      </g>
    </svg>
  );
}
